export default {
  optOut: state => state.optOut,
  mobilePortrait: state => state.mobilePortrait,
  fullscreenEnabled: state => state.fullscreenEnabled,
  topmenu: state => state.topmenu,
  route: state => state.route,
  getThemedVar: state => (prop, def) => (state.theme && prop in state.theme
    ? state.theme[prop]
    : def),
  contactFormFieldsAllowed: (_, getters) => ({
    zip: getters.getThemedVar('unitSingleContactFormZip', false),
    birthyear: getters.getThemedVar('unitSingleContactFormBirthyear', false),
    message: getters.getThemedVar('unitSingleContactFormMessage', true),
  }),
  primaryColor: (_, getters, __, rootGetters) => getters.getThemedVar(
    'primaryColor',
    rootGetters['project/settings'].profile_color1,
  ),
  exteriorId: state => state.routeParams && +state.routeParams.exteriorId,
  exteriorNavBarVisible: state => state.exteriorNavBarVisible,
  isMiniMapVisible: state => state.isMiniMapVisible,
};
